// const tabs = document.querySelectorAll('.product-info-tabs .tab-list .tab');
// const panels = document.querySelectorAll('.product-info-tabs .tab-content .tab-panel');

// export function initTabs() {
//     if (tabs) {
//         // Add event listeners to tabs
//         tabs.forEach(tab => {
//             tab.addEventListener('click', function() {
//                 removeActiveClass();

//                 // set aria-selected to true on the clicked tab
//                 this.setAttribute('aria-selected', 'true');

//                 // Activate the clicked tab
//                 this.classList.add('active');

//                 // Find the corresponding tab panel by ID and activate it
//                 const tabId = this.getAttribute('data-tab');
//                 document.querySelector(`.product-info-tabs .tab-content #${tabId}`).classList.add('active');
//             });
//         });
//     }

//     function removeActiveClass() {
//         tabs.forEach(tab => {
//             tab.classList.remove('active');
//             tab.setAttribute('aria-selected', 'false');
//         });
//         panels.forEach(panel => panel.classList.remove('active'));
//     }
// }



function centerActiveTab() {
  const tabList = document.querySelector('.tab-list') as HTMLElement;
  const activeTab = tabList.querySelector('.tab.active') as HTMLElement;

  if (!tabList || !activeTab) return;

  const offset = activeTab.offsetLeft;
  const tabWidth = activeTab.offsetWidth;
  const containerWidth = tabList.clientWidth;
  const scrollWidth = tabList.scrollWidth;

  let scrollTo = offset - (containerWidth / 2) + (tabWidth / 2);
  scrollTo = Math.max(0, Math.min(scrollTo, scrollWidth - containerWidth));

  tabList.scrollTo({
    left: scrollTo,
    behavior: 'smooth',
  });
}

function updateScrollUI() {
  const wrapper = document.querySelector('.tab-wrapper');
  const tabList = document.querySelector('.tab-list') as HTMLElement;
  const leftArrow = document.querySelector('.scroll-arrow.left') as HTMLElement;
  const rightArrow = document.querySelector('.scroll-arrow.right') as HTMLElement;

  if (!wrapper || !tabList || !leftArrow || !rightArrow) return;

  const scrollLeft = tabList.scrollLeft;
  const scrollWidth = tabList.scrollWidth;
  const clientWidth = tabList.clientWidth;

  const atStart = scrollLeft <= 0;
  const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

  wrapper.classList.toggle('fade-left', !atStart);
  wrapper.classList.toggle('fade-right', !atEnd);

  leftArrow.classList.toggle('inactive', atStart);
  rightArrow.classList.toggle('inactive', atEnd);
}

export function initTabScrollUI() {
  const tabList = document.querySelector('.tab-list') as HTMLElement;
  const leftArrow = document.querySelector('.scroll-arrow.left') as HTMLElement;
  const rightArrow = document.querySelector('.scroll-arrow.right') as HTMLElement;
  const tabs = document.querySelectorAll('.tab-list .tab');

  if (!tabList || !leftArrow || !rightArrow) return;

  // Scroll on arrow click
  leftArrow.addEventListener('click', () => {
    tabList.scrollBy({ left: -120, behavior: 'smooth' });
  });

  rightArrow.addEventListener('click', () => {
    tabList.scrollBy({ left: 120, behavior: 'smooth' });
  });

  // Watch scroll and resize
  tabList.addEventListener('scroll', updateScrollUI);
  window.addEventListener('resize', updateScrollUI);

  // Watch tab click to re-center
tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    // Remove active and aria-selected from all tabs
    tabs.forEach(t => {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
    });

    // Set active and aria-selected on clicked tab
    tab.classList.add('active');
    tab.setAttribute('aria-selected', 'true');

    // Get target panel ID from data-tab or aria-controls
    const targetId = tab.getAttribute('data-tab') || tab.getAttribute('aria-controls');
    const targetPanel = document.getElementById(targetId!); // ! asserts it's non-null

    // Hide all tab panels
    const panels = document.querySelectorAll('.tab-panel');
    panels.forEach(panel => panel.classList.remove('active'));

    // Show the correct one
    if (targetPanel) {
      targetPanel.classList.add('active');
    }

    centerActiveTab();
    updateScrollUI();
  });
});


  // Initial update
  centerActiveTab();
  updateScrollUI();
}

// Initialize on DOM ready
window.addEventListener('DOMContentLoaded', initTabScrollUI);

